/* eslint-disable indent */
// @flow
import React from 'react';
// import cn from 'classnames';
import _ from 'lodash';
// import { EVENT_TYPES, PART_TITLES } from 'client/constants/common';
import { Icon } from '../../Icon';
import { Responsive } from '../../Responsive';

import css from './Tactic.scss';

const TACTIC_SHEMA = {
	'3:5:2': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '45%',
		},
		{
			top: '27%',
			right: '80%',
		},
		{
			top: '27%',
			right: '9%',
		},
		{
			top: '39%',
			right: '65%',
		},
		{
			top: '39%',
			right: '25%',
		},
		{
			top: '52%',
			right: '80%',
		},

		{
			top: '52%',
			right: '45%',
		},
		{
			top: '52%',
			right: '9%',
		},
		{
			top: '63%',
			right: '65%',
		},
		{
			top: '63%',
			right: '25%',
		},
	],
	'4:3:3': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '65%',
		},
		{
			top: '16%',
			right: '25%',
		},
		{
			top: '27%',
			right: '80%',
		},
		{
			top: '27%',
			right: '9%',
		},
		{
			top: '39%',
			right: '80%',
		},
		{
			top: '39%',
			right: '45%',
		},
		{
			top: '39%',
			right: '9%',
		},
		{
			top: '52%',
			right: '80%',
		},
		{
			top: '52%',
			right: '9%',
		},
		{
			top: '63%',
			right: '45%',
		},
	],
	'4:4:2': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '65%',
		},
		{
			top: '16%',
			right: '25%',
		},
		{
			top: '27%',
			right: '80%',
		},
		{
			top: '27%',
			right: '9%',
		},
		{
			top: '39%',
			right: '65%',
		},
		{
			top: '39%',
			right: '25%',
		},
		{
			top: '52%',
			right: '80%',
		},
		{
			top: '52%',
			right: '9%',
		},
		{
			top: '63%',
			right: '65%',
		},
		{
			top: '63%',
			right: '25%',
		},
	],
	'4:5:1': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '65%',
		},
		{
			top: '16%',
			right: '25%',
		},
		{
			top: '27%',
			right: '80%',
		},
		{
			top: '27%',
			right: '9%',
		},
		{
			top: '39%',
			right: '65%',
		},
		{
			top: '39%',
			right: '25%',
		},
		{
			top: '52%',
			right: '80%',
		},
		{
			top: '52%',
			right: '45%',
		},
		{
			top: '52%',
			right: '9%',
		},
		{
			top: '63%',
			right: '45%',
		},
	],
	'5:3:2': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '75%',
		},
		{
			top: '16%',
			right: '45%',
		},
		{
			top: '16%',
			right: '15%',
		},
		{
			top: '27%',
			right: '80%',
		},
		{
			top: '27%',
			right: '9%',
		},
		{
			top: '39%',
			right: '65%',
		},
		{
			top: '39%',
			right: '25%',
		},
		{
			top: '52%',
			right: '45%',
		},
		{
			top: '63%',
			right: '65%',
		},
		{
			top: '63%',
			right: '25%',
		},
	],
	'5:4:1': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '75%',
		},
		{
			top: '16%',
			right: '45%',
		},
		{
			top: '16%',
			right: '15%',
		},
		{
			top: '27%',
			right: '80%',
		},
		{
			top: '27%',
			right: '9%',
		},
		{
			top: '39%',
			right: '65%',
		},
		{
			top: '39%',
			right: '25%',
		},
		{
			top: '52%',
			right: '75%',
		},
		{
			top: '52%',
			right: '15%',
		},
		{
			top: '63%',
			right: '45%',
		},
	],
	'4:2:3:1': [
		{
			top: '3%',
			right: '45%',
		},
		{
			top: '16%',
			right: '80%',
		},
		{
			top: '16%',
			right: '57%',
		},
		{
			top: '16%',
			right: '33%',
		},
		{
			top: '16%',
			right: '9%',
		},
		{
			top: '27%',
			right: '57%',
		},
		{
			top: '27%',
			right: '33%',
		},
		{
			top: '45%',
			right: '69%',
		},
		{
			top: '45%',
			right: '45%',
		},
		{
			top: '45%',
			right: '21%',
		},
		{
			top: '63%',
			right: '45%',
		},
	],
};

const TACTIC_SHEMA_MOBILE = {
	'3:5:2': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '15%',
			right: '43%',
		},
		{
			top: '27%',
			right: '79%',
		},
		{
			top: '27%',
			right: '10%',
		},
		{
			top: '40%',
			right: '61%',
		},
		{
			top: '40%',
			right: '23%',
		},
		{
			top: '53%',
			right: '79%',
		},
		{
			top: '53%',
			right: '43%',
		},
		{
			top: '53%',
			right: '10%',
		},
		{
			top: '67%',
			right: '61%',
		},
		{
			top: '67%',
			right: '23%',
		},
	],
	'4:3:3': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '15%',
			right: '60%',
		},
		{
			top: '15%',
			right: '23%',
		},
		{
			top: '27%',
			right: '79%',
		},
		{
			top: '27%',
			right: '10%',
		},
		{
			top: '40%',
			right: '79%',
		},
		{
			top: '40%',
			right: '43%',
		},
		{
			top: '40%',
			right: '10%',
		},
		{
			top: '53%',
			right: '79%',
		},
		{
			top: '53%',
			right: '10%',
		},
		{
			top: '67%',
			right: '43%',
		},
	],
	'4:4:2': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '15%',
			right: '61%',
		},
		{
			top: '15%',
			right: '23%',
		},
		{
			top: '27%',
			right: '79%',
		},
		{
			top: '27%',
			right: '10%',
		},
		{
			top: '40%',
			right: '61%',
		},
		{
			top: '40%',
			right: '23%',
		},
		{
			top: '53%',
			right: '79%',
		},
		{
			top: '53%',
			right: '10%',
		},
		{
			top: '67%',
			right: '61%',
		},
		{
			top: '67%',
			right: '23%',
		},
	],
	'4:5:1': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '15%',
			right: '61%',
		},
		{
			top: '15%',
			right: '23%',
		},
		{
			top: '27%',
			right: '79%',
		},
		{
			top: '27%',
			right: '10%',
		},
		{
			top: '40%',
			right: '61%',
		},
		{
			top: '40%',
			right: '23%',
		},
		{
			top: '53%',
			right: '79%',
		},
		{
			top: '53%',
			right: '43%',
		},
		{
			top: '53%',
			right: '10%',
		},
		{
			top: '67%',
			right: '43%',
		},
	],
	'5:3:2': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '15%',
			right: '72%',
		},
		{
			top: '15%',
			right: '43%',
		},
		{
			top: '15%',
			right: '16%',
		},
		{
			top: '27%',
			right: '79%',
		},
		{
			top: '27%',
			right: '10%',
		},
		{
			top: '40%',
			right: '61%',
		},
		{
			top: '40%',
			right: '25%',
		},
		{
			top: '53%',
			right: '43%',
		},
		{
			top: '67%',
			right: '61%',
		},
		{
			top: '67%',
			right: '23%',
		},
	],
	'5:4:1': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '15%',
			right: '72%',
		},
		{
			top: '15%',
			right: '43%',
		},
		{
			top: '15%',
			right: '16%',
		},
		{
			top: '27%',
			right: '79%',
		},
		{
			top: '27%',
			right: '10%',
		},
		{
			top: '40%',
			right: '62%',
		},
		{
			top: '40%',
			right: '23%',
		},
		{
			top: '53%',
			right: '79%',
		},
		{
			top: '53%',
			right: '16%',
		},
		{
			top: '67%',
			right: '43%',
		},
	],
	'4:2:3:1': [
		{
			top: '3%',
			right: '43%',
		},
		{
			top: '19%',
			right: '79%',
		},
		{
			top: '15%',
			right: '57%',
		},
		{
			top: '15%',
			right: '27.5%',
		},
		{
			top: '19%',
			right: '9%',
		},
		{
			top: '29%',
			right: '57%',
		},
		{
			top: '29%',
			right: '33%',
		},
		{
			top: '45%',
			right: '68%',
		},
		{
			top: '45%',
			right: '43%',
		},
		{
			top: '45%',
			right: '19%',
		},
		{
			top: '67%',
			right: '43%',
		},
	],
};

const SUBSTITUTE_POSITIONS = [
	{
		bottom: '16%',
		right: '9%',
	},
	{
		bottom: '16%',
		right: '45%',
	},
	{
		bottom: '16%',
		right: '80%',
	},
	{
		bottom: '5%',
		right: '65%',
	},
	{
		bottom: '5%',
		right: '25%',
	},
];

const SUBSTITUTE_POSITIONS_MOBILE = [
	{
		bottom: '13%',
		right: '9%',
	},
	{
		bottom: '13%',
		right: '43%',
	},
	{
		bottom: '13%',
		right: '79%',
	},
	{
		bottom: '3%',
		right: '61%',
	},
	{
		bottom: '3%',
		right: '23%',
	},
];

const COLORS = {
	BLACK: '#000',
	WHITE: '#fff',
	YELLOW: '#fcec24',
	RED: '#d10504',
	GREEN: '#1c6f36',
	BLUE: '#2f4d8b',
	LIGHT_BLUE: '#74acdf',
	ORANGE: '#f9741b',
	PINK: '#df99ad',
	VIOLET: '#4f3481',
	GRAY: '#7f8084',
	BEIGE: '#e2c079',
	BROWN: '#55381d',
};

const SHIRTS_COLOR = {
	'1': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.YELLOW,
	},
	'2': {
		color: COLORS.RED,
		secondaryColor: COLORS.WHITE,
	},
	'3': {
		color: COLORS.GREEN,
		secondaryColor: COLORS.WHITE,
	},
	'4': {
		color: COLORS.BLUE,
		secondaryColor: COLORS.WHITE,
	},
	'5': {
		color: COLORS.WHITE,
		secondaryColor: COLORS.WHITE,
	},
	'6': {
		color: COLORS.RED,
		secondaryColor: COLORS.BLUE,
	},
	'7': {
		color: COLORS.BLUE,
		secondaryColor: COLORS.BLUE,
	},
	'8': {
		color: COLORS.BLUE,
		secondaryColor: COLORS.BLUE,
	},
	'9': {
		color: COLORS.YELLOW,
		secondaryColor: COLORS.YELLOW,
	},
	'10': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.RED,
	},
	'11': {
		color: COLORS.RED,
		secondaryColor: COLORS.YELLOW,
	},
	'12': {
		color: COLORS.RED,
		secondaryColor: COLORS.RED,
	},
	'13': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.ORANGE,
	},
	'14': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.WHITE,
	},
	'15': {
		color: COLORS.BLUE,
		secondaryColor: COLORS.WHITE,
	},
	'16': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.BLACK,
	},
	'17': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.BLUE,
	},
	'18': {
		color: COLORS.GREEN,
		secondaryColor: COLORS.GREEN,
	},
	'19': {
		color: COLORS.YELLOW,
		secondaryColor: COLORS.WHITE,
	},
	'20': {
		color: COLORS.GREEN,
		secondaryColor: COLORS.YELLOW,
	},
	'21': {
		color: COLORS.PINK,
		secondaryColor: COLORS.PINK,
	},
	'22': {
		color: COLORS.VIOLET,
		secondaryColor: COLORS.VIOLET,
	},
	'23': {
		color: COLORS.ORANGE,
		secondaryColor: COLORS.ORANGE,
	},
	'24': {
		color: COLORS.GRAY,
		secondaryColor: COLORS.GRAY,
	},
	'25': {
		color: COLORS.LIGHT_BLUE,
		secondaryColor: COLORS.LIGHT_BLUE,
	},
	'26': {
		color: COLORS.BEIGE,
		secondaryColor: COLORS.BEIGE,
	},
	'27': {
		color: COLORS.BROWN,
		secondaryColor: COLORS.BROWN,
	},
	'28': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.GREEN,
	},
	'29': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.BROWN,
	},
	'30': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.PINK,
	},
	'31': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.VIOLET,
	},
	'32': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.GRAY,
	},
	'33': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.LIGHT_BLUE,
	},
	'34': {
		color: COLORS.BLACK,
		secondaryColor: COLORS.BEIGE,
	},
	'35': {
		color: COLORS.BROWN,
		secondaryColor: COLORS.WHITE,
	},
	'36': {
		color: COLORS.PINK,
		secondaryColor: COLORS.WHITE,
	},
	'37': {
		color: COLORS.VIOLET,
		secondaryColor: COLORS.WHITE,
	},
	'38': {
		color: COLORS.ORANGE,
		secondaryColor: COLORS.WHITE,
	},
	'39': {
		color: COLORS.GRAY,
		secondaryColor: COLORS.WHITE,
	},
	'40': {
		color: COLORS.BEIGE,
		secondaryColor: COLORS.WHITE,
	},
	'41': {
		color: COLORS.RED,
		secondaryColor: COLORS.ORANGE,
	},
	'42': {
		color: COLORS.RED,
		secondaryColor: COLORS.GREEN,
	},
	'43': {
		color: COLORS.BLUE,
		secondaryColor: COLORS.PINK,
	},
	'44': {
		color: COLORS.LIGHT_BLUE,
		secondaryColor: COLORS.YELLOW,
	},
	'45': {
		color: COLORS.BLUE,
		secondaryColor: COLORS.GREEN,
	},
	'46': {
		color: COLORS.RED,
		secondaryColor: COLORS.PINK,
	},
};

type Props = {
	homeLineUp: any[],
	homeTactic: string,
	homeColor: number,
	guestLineUp: any[],
	guestTactic: string,
	guestColor: number,
	cardsEvents: any[],
	playersOutEvents: any[],
};

export function Tactic({
	homeLineUp,
	homeTactic,
	homeColor,
	guestLineUp,
	guestTactic,
	guestColor,
	cardsEvents,
	playersOutEvents,
}: Props) {
	// prevent new tactic shema error
	if (!_.keys(TACTIC_SHEMA).includes(homeTactic) || !_.keys(TACTIC_SHEMA).includes(guestTactic)) {
		return null;
	}

	const renderField = (tactic, lineUp, shirtColor) => {
		const startLineUpPlayers = _.filter(lineUp, p => p.IsStartLineup);
		const subtitutePlayers = _.filter(lineUp, p => !p.IsStartLineup);

		return (
			<div className={css.field}>
				<Icon
					type={Responsive.isMatching(Responsive.MOBILE) ? 'field-mobile' : 'field'}
					className={css.fieldIcon}
				/>
				{_.map(startLineUpPlayers, (player, index) => renderMainPlayer(player, index, tactic, shirtColor))}
				{_.map(subtitutePlayers, (player, index) => renderSubtitutePlayer(player, index, tactic, shirtColor))}
			</div>
		);
	};

	const renderMainPlayer = (player, index, tactic, shirtColor) => {
		const playerFall = _.filter(cardsEvents, fall => fall.Player === player.Name);
		const playerOut = _.find(playersOutEvents, { PlayerOut: player.Name });
		// eslint-disable-next-line no-nested-ternary
		const nameSplited = player.Name
			? player.Name.split(' ').length === 1
				? player.Name
				: player.Name.split(' ')
						.slice(1)
						.join(' ')
			: '';
		// const name =
		// 	// eslint-disable-next-line no-nested-ternary
		// 	_.size(nameSplited) > 1
		// 		? nameSplited[1] && _.size(nameSplited[1]) < 4
		// 			? `${nameSplited[1]} ${nameSplited[0]}`
		// 			: nameSplited[1]
		// 		: nameSplited[0];

		const tacticShema = Responsive.isMatching(Responsive.DESKTOP)
			? { ...TACTIC_SHEMA[tactic][index] }
			: { ...TACTIC_SHEMA_MOBILE[tactic][index] };

		return (
			<div className={css.player} style={tacticShema} key={player.Name}>
				{playerContent(shirtColor, nameSplited, player, playerFall, playerOut)}
			</div>
		);
	};

	const renderSubtitutePlayer = (player, index, tactic, shirtColor) => {
		const playerFall = _.filter(cardsEvents, fall => fall.Player === player.Name);
		const playerOut = _.find(playersOutEvents, { Player: player.Name });
		// eslint-disable-next-line no-nested-ternary
		const nameSplited = player.Name
			? player.Name.split(' ').length === 1
				? player.Name
				: player.Name.split(' ')
						.slice(1)
						.join(' ')
			: '';

		// const name =
		// 	// eslint-disable-next-line no-nested-ternary
		// 	_.size(nameSplited) > 1
		// 		? nameSplited[1] && _.size(nameSplited[1]) < 4
		// 			? `${nameSplited[1]} ${nameSplited[0]}`
		// 			: nameSplited[1]
		// 		: nameSplited[0];

		const tacticShema = Responsive.isMatching(Responsive.DESKTOP)
			? { ...SUBSTITUTE_POSITIONS[index] }
			: { ...SUBSTITUTE_POSITIONS_MOBILE[index] };

		return (
			<div className={css.player} style={tacticShema} key={player.Name}>
				{playerContent(shirtColor, nameSplited, player, playerFall, playerOut)}
			</div>
		);
	};

	const playerContent = (shirtColor, name, player, playerFall, playerOut) => {
		return (
			<>
				<Icon type="shirt" className={css.shirt} {...SHIRTS_COLOR[shirtColor]} />
				<p className={css.name}>{name}</p>
				{player.Grade > 0 && <div className={css.grade}>{player.Grade}</div>}
				{playerFall && (
					<>
						<div className={css.card}>
							{_.map(playerFall, fall => (
								<Icon type={fall.Event} key={fall.Text} />
							))}
						</div>
					</>
				)}
				{playerOut && (
					<>
						<Icon type="subtitute-in" className={css.playerOutIcon} />
						<div className={css.fallMinute}>{`(${playerOut.Minute})`}</div>
					</>
				)}
			</>
		);
	};

	return (
		<div className={css.tactic}>
			{renderField(homeTactic, homeLineUp, homeColor)}
			{renderField(guestTactic, guestLineUp, guestColor)}
		</div>
	);
}
